<template>
    
        <section class="login_section">
            <div class="login-wrap">
                <div class="login-div">
                    <div class="login-header"><img sizes="(max-width: 1000px) 100vw, 1000px"
                            srcset="@/assets/images/NewSelf_Logo-p-500.webp 500w, @/assets/images/NewSelf_Logo-p-800.webp 800w, @/assets/images/NewSelf_Logo.webp 1000w" alt="" src="@/assets/images/NewSelf_Logo.webp" loading="lazy" class="image-167"></div>
                    <div class="login-form-div">
                        <h1 class="heading-45">Welcome back</h1>
                        <div class="text-block-201">Become your newself.</div>
                        <div class="text-block-203">New user? <a href="/" class="link-12">Create an account <span
                                    class="text-span-182">-&gt;</span></a>
                        </div>
                        <div class="div-block-1041">
                            <div class="w-form">
                                <form id="email-form" name="email-form" data-name="Email Form" method="get"
                                    class="form-5" @submit.prevent="onSubmit">
                                    <input class="login-user w-input" maxlength="256" name="email"
                                        v-model="email" data-name="Email"
                                        placeholder="Enter your email" type="email" id="email" @blur="validateEmail">
                                    <div class="w-form-fail" style="display:block; margin-bottom: 10px;" v-if="emailError">
                                        <div>Please enter a valid email address.</div>
                                    </div>
                                    <input class="login-pw w-input" maxlength="256" name="password" data-name="Password"
                                        v-model="password" placeholder="Password" type="password" id="password"
                                        required="">
                                    <button class="submit-button-6 w-button" :disabled="submitted"
                                        style="padding-top:12px">
                                        <div v-if="submitted">
                                            <svg xmlns="http://www.w3.org/2000/svg"
                                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                                style="margin: auto; background: none; display: block; shape-rendering: auto;"
                                                width="15px" height="15px" viewBox="0 0 100 100"
                                                preserveAspectRatio="xMidYMid">
                                                <circle cx="50" cy="50" fill="none" stroke="blue" stroke-width="10"
                                                    r="35" stroke-dasharray="164.93361431346415 56.97787143782138">
                                                    <animateTransform attributeName="transform" type="rotate"
                                                        repeatCount="indefinite" dur="0.53475935828877s"
                                                        values="0 50 50;360 50 50" keyTimes="0;1"></animateTransform>
                                                </circle>
                                            </svg>
                                        </div>
                                        <div v-else>
                                            <div class="">Log In</div>
                                        </div>
                                    </button>

                                    <div class="text-block-1586">Forgot your login details?</div>
                                    <div class="text-block-1587">
                                        <a href="/forgot-password" class="link-80">Reset your password</a>
                                    </div>
                                </form>
                                <div class="w-form-done">
                                    <div>Thank you! Your submission has been received!</div>
                                </div>
                                <div class="w-form-fail">
                                    <div>Oops! Something went wrong while submitting the form.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="height:280px"></div>
        </section>
    
</template>

<script>
export default {
    name: 'LoginPage',
    props: ['baseUrl'],
    data() {
        return {
            email: null,
            password: null,
            submitted: false,
            err: false,
            errmsg: "",
            emailError: false,
        }
    },
    computed: {
        getUrl() {
            if (this.$route.query.page_ref) {
                return `/home?page_ref=${this.$route.query.page_ref}`
            } else {
                return "/home"
            }
        }
    },
    beforeCreate() {
        // Force light theme - login page should never show dark mode.
        // Only the attribute is cleared. Deleting _ymain_theme_ here threw away
        // the customer's own choice on every visit to this page, so anyone who
        // had picked dark in the dashboard lost it the next time they logged in.
        document.documentElement.removeAttribute('data-theme')
        document.body.style.backgroundColor = '#ffffff'
    },
    created() {
        // Redirect logged-in users away from login page
        if (this.$store.getters.isAuthenticated) {
            const pageRef = this.$route.query.page_ref
                ? this.extractFinalDestination(this.$route.query.page_ref)
                : '/home';
            this.$router.replace(pageRef);
        }

        // Prefill email: URL query param takes priority, then fall back to store
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const urlEmail = this.$route.query.email;
        if (urlEmail && emailRegex.test(urlEmail)) {
            this.email = urlEmail;
        } else {
            const user = this.$store.getters.user;
            if (user && user.email && emailRegex.test(user.email)) {
                this.email = user.email;
            }
        }
    },
    methods: {
        isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        },
        validateEmail() {
            if (this.email && this.email.trim()) {
                this.emailError = !this.isValidEmail(this.email.trim());
            } else {
                this.emailError = false;
            }
        },
        extractFinalDestination(url) {
            // Recursively decode and extract the final non-login destination
            let decoded = url;
            let prev = '';

            // Keep decoding until no more changes
            while (decoded !== prev) {
                prev = decoded;
                try {
                    decoded = decodeURIComponent(decoded);
                } catch (e) {
                    break;
                }
            }

            // Check if it contains a page_ref parameter, extract the deepest destination
            const pageRefMatch = decoded.match(/page_ref=(.+)/);
            if (pageRefMatch) {
                return this.extractFinalDestination(pageRefMatch[1]);
            }

            // Remove any query string from the final path and check if it's a login page
            const pathOnly = decoded.split('?')[0];
            if (pathOnly === '/login' || pathOnly === 'login') {
                return '/home';
            }

            return pathOnly || '/home';
        },
        onSubmit() {
            this.validateEmail();
            if (this.emailError || !this.email || !this.email.trim()) {
                this.err = true;
                this.errmsg = "Please enter a valid email address.";
                return;
            }
            this.submitted = true;
            this.err = false;
            this.$axios.post(`${this.baseUrl}/api/login`, {
                password: this.password,
                email: this.email.toLowerCase(),
            }).then(async response => {
                if (response.data.status == 'success') {
                    this.$store.dispatch("doLogin", response.data);

                    // Fetch full user details (includes dob, shipping)
                    try {
                        const detailsResponse = await this.$axios.get(`${this.baseUrl}/api/current-user-details`);
                        if (detailsResponse.data.success && detailsResponse.data.user) {
                            this.$store.dispatch("UpdateUserData", detailsResponse.data.user);
                        }
                        if (detailsResponse.data.shipping) {
                            this.$store.dispatch("saveShippingDetails", detailsResponse.data.shipping);
                        }
                        if (detailsResponse.data.referralLink) {
                            this.$store.dispatch("setReferralLink", detailsResponse.data.referralLink);
                        }
                    } catch (err) {
                        console.error('Failed to fetch user details:', err);
                    }

                    const pageRef = this.$route.query.page_ref
                        ? this.extractFinalDestination(this.$route.query.page_ref)
                        : '/home';
                    this.$router.push(pageRef);
                } else {
                    this.submitted = false;
                    this.err = true;
                    this.errmsg = response.data.message;
                }
            }).catch(error => {
                console.log(error.message)
                this.submitted = false;
                this.err = true;
                this.errmsg = 'Email or password entered is incorrect. Please try again or <router-link to="/forgot-password">reset your password.</router-link>'
            });

        },
    }
}
</script>

<style scoped>
/* Force light theme on login page - override any dark mode */
.login_section {
    background-color: #ffffff !important;
    color: #000000 !important;
}

/* Button styles - force light theme colors */
.submit-button-6 {
    background-color: #e9ff86 !important;
    color: #08466f !important;
    border-color: #08466f !important;
}
.submit-button-6:hover {
    background-color: #d4eb79 !important;
}

/* Link styles - force light theme colors */
.link-12,
.link-80 {
    color: #08466f !important;
}
.link-12:hover,
.link-80:hover {
    color: #065a60 !important;
}
</style>
